import { defaultBillingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultBillingAddress";
import { defaultShippingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultShippingAddress";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

defaultBillingAddressStyles.editLink = {
    css: css`
        margin-left: 10px;
        margin-top: 2px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: ${TYPOGRAPHY.size.smaller};
                    margin-top: 0px;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};

defaultBillingAddressStyles.headingText = {
    css: css`
        font-weight: ${TYPOGRAPHY.weight.mediumbold};
        font-size: ${TYPOGRAPHY.size.large};
        color: ${getProp("theme.typography.p.color")};
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: ${TYPOGRAPHY.size.smaller};
                    color: ${getProp("theme.typography.p.color")};
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
